import React from "react";
import { useEffect, useState } from "react";
import CustomInput from "../components/formik/CustomInput";
import CustomSelect from "../components/formik/CustomSelect";
import { Panel, PanelBody, PanelHeader } from "../components/panel/panel";
import { findFiscalRegimes } from "../services/CatalogService";  
import LogoUploadDangerZone from '../components/formik/LogoUploadDangerZone';
import { Form, Row, Col } from "react-bootstrap";
import { findFiscalRegimesByCoincidence } from "../services/CatalogService";
import  CustomAutoComplete  from "../components/formik/CustomAutoComplete";
import { SketchPicker } from "react-color";

const ConfigBillingForm = ({ formik }) => {
  const [regimenesFiscales, setRegimenesFiscales] = useState([]);

  return (
  <Panel>
  <PanelHeader noButton={true}>Configuración para facturar</PanelHeader>
  <PanelBody>
    <div className="row">
      <div className="col-sm-4">
        <CustomInput
          label="RFC"
          field="rfc"
          formik={formik}
          required
        />
        <CustomInput
          label="Nombre"
          field="name"
          formik={formik}
          required
        />
         <CustomInput
          label="Descripción"
          field="description"
          formik={formik}
        />
        <CustomInput
          label="Código Postal"
          field="postalCode"
          formik={formik}
          required
        />
        <CustomAutoComplete
            formik={formik}
            field="fiscalRegimeId"
            label="Régimen Fiscal"
            searchFunction={findFiscalRegimesByCoincidence}
            descriptionField="description" 
            width = "95%"
          />
        {formik.errors.fiscalRegimeId && (
          <div className="invalid-feedback d-block">
            {formik.errors.fiscalRegimeId}
          </div>
        )}
      </div>

      <div className="col-sm-4">
        <div className="form-group">
          <label className="form-label">Color Primario *</label>
          <SketchPicker
            color={formik.values.primaryColor || "#000000"}
            onChangeComplete={(color) => {
              formik.setFieldValue("primaryColor", color.hex);
            }}
          />
        </div>
      </div>
       
      <div className="col-sm-4">
        <LogoUploadDangerZone formik={formik} />
      </div>
    </div>
  </PanelBody>
</Panel>

  );
};

export default ConfigBillingForm;